/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Duration_ShortInputs */

const en_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURA`)
};

const fr_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DUREE`)
};

const de_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURA`)
};

const it_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURA`)
};

const ru_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДУРА`)
};

const es_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURA`)
};

const zh_cn2_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`杜拉`)
};

const ja_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デュラ`)
};

const hi_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्यूरा`)
};

const pt_pt2_ccsl_export_header_duration_short = /** @type {(inputs: Ccsl_Export_Header_Duration_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURA`)
};

/**
* | output |
* | --- |
* | "DURA" |
*
* @param {Ccsl_Export_Header_Duration_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_duration_short = /** @type {((inputs?: Ccsl_Export_Header_Duration_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Duration_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_duration_short(inputs)
	if (locale === "de") return de_ccsl_export_header_duration_short(inputs)
	if (locale === "it") return it_ccsl_export_header_duration_short(inputs)
	if (locale === "ru") return ru_ccsl_export_header_duration_short(inputs)
	if (locale === "es") return es_ccsl_export_header_duration_short(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_duration_short(inputs)
	if (locale === "ja") return ja_ccsl_export_header_duration_short(inputs)
	if (locale === "hi") return hi_ccsl_export_header_duration_short(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_duration_short(inputs)
	return en_ccsl_export_header_duration_short(inputs)
});